
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/instant-vat",
      function () {
        return require("private-next-pages/v2/instant-vat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/instant-vat"])
      });
    }
  